var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('z-responsive-modal',{attrs:{"show":_vm.showModal,"hide-close":"","size":"md"},on:{"update:show":function($event){_vm.showModal=$event},"hide":_vm.handleClose}},[_c('form-create-client',{on:{"close":_vm.handleClose}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }